import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=065e4c5a&scoped=true&"
import script from "./grid.vue?vue&type=script&lang=js&"
export * from "./grid.vue?vue&type=script&lang=js&"
import style0 from "./grid.vue?vue&type=style&index=0&id=065e4c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e4c5a",
  null
  
)

export default component.exports